const Network = require('./architecture/network.js');

/**
 *
 */
const GAN = function(dataset, options) {
  this.generator;
  this.discriminator;
  this.raw_data;
};

GAN.prototype = {
  train: function(iterations) {

  },
  data: function(length) {

  },
};
